@if (contractViewModel) {
<div class="apply-one-grid apply-one-style">
  <div class="site-width">
    <div class="container-fluid">
      <h1 class="pt-3 d-none d-md-block" data-e2e="title">{{"dashboard.removeContracts.title" | translate}}</h1>
      <div class="row">
        <div class="col-12 col-md-10 col-xl-8">
          <p class="alert alert-info" role="alert" data-e2e="alert-info">
            <span class="alert-icon icon-info"></span>
            <span>
              {{'dashboard.removeContracts.info1' | translate}}
              <br />
              {{'dashboard.removeContracts.info2' | translate}}
            </span>
          </p>
        </div>
      </div>
      <div class="lead font-weight-bold selection-title" data-e2e="sub-title">
        {{"dashboard.removeContracts.selectionLabel" | translate}}
      </div>
      <ul class="items-list mb-3">
        @for (contract of activeContractViewModel; track contract) {
        <li data-e2e="contract-item">
          <a
            [href]="removeContractLink | link:getLinkParam(contract) | async"
            (click)="removeContract(contract);false"
            class="items-list-item"
            data-e2e="remove-contract-link"
          >
            <div class="item-container">
              <div class="item-text">
                <span data-e2e="item-title">{{contract?.offerName}}</span>
                <small
                  class="item-desc"
                  data-e2e="item-offer"
                  [innerHTML]="contract.detail | phone | insecable"
                ></small>
                @if (contract?.delegation) {
                <small class="item-desc font-weight-bold delegation">
                  {{"dashboard.removeContracts.delegation" | translate}} {{contract.delegation}}
                </small>
                }
                <small class="item-desc font-weight-bold text-orange1" data-e2e="remove-contract-displayName">
                  {{contract?.member?.displayName}}
                </small>
              </div>
            </div>
          </a>
        </li>
        }
      </ul>
    </div>
  </div>
</div>
} @else {
<div class="apply-one-grid apply-one-style">
  <div class="site-width">
    <div class="container-fluid">
      <div class="py-5" data-e2e="spinner">
        <ecm-mat-spinner [centered]="true"></ecm-mat-spinner>
      </div>
    </div>
  </div>
</div>
}
